import api from './api';

const medicalRecordService = {
  // Crear historia clínica
  createMedicalRecord: async (data) => {
    const response = await api.post('/medical-records', data);
    // FIX: Retornar la estructura completa para facilitar extracción del ID
    // CRITICAL FIX: Use nullish coalescing (??) instead of logical OR (||)
    // to prevent masking API failures and mishandling falsy values
    return {
      success: response.data?.success ?? true,
      data: response.data?.data ?? response.data,
      message: response.data?.message
    };
  },

  // Actualizar historia clínica existente
  updateMedicalRecord: async (id, data) => {
    const response = await api.put(`/medical-records/${id}`, data);
    return {
      success: response.data?.success ?? true,
      data: response.data?.data ?? response.data,
      message: response.data?.message
    };
  },

  // Obtener historia específica
  getMedicalRecord: async (id) => {
    const response = await api.get(`/medical-records/${id}`);
    return {
      success: response.data?.success ?? true,
      data: response.data?.data ?? response.data
    };
  },

  // Obtener todas las historias de un paciente específico (para doctor)
  getPatientMedicalRecords: async (patientId) => {
    const response = await api.get(`/medical-records/patient/${patientId}`);
    return {
      success: response.data?.success ?? true,
      data: response.data?.data ?? response.data,
      count: response.data?.count
    };
  },

  // Obtener historia clínica por cita - FIX: Retornar estructura consistente
  getByAppointment: async (appointmentId) => {
    const response = await api.get(`/medical-records/appointment/${appointmentId}`);
    return {
      success: response.data?.success ?? true,
      data: response.data?.data,
      message: response.data?.message
    };
  },

  // Generar y descargar un documento de la historia (two-step: dl_token + window.open).
  // doc: 'historia' | 'medicamentos' | 'examenes' | 'incapacidad'
  generatePDF: async (medicalRecordId, doc = 'historia') => {
    if (!medicalRecordId) {
      throw new Error('ID de historia clínica inválido');
    }
    // Paso 1: token de un solo uso (60s TTL) para ESE documento. El tipo de
    // documento viaja dentro del token: uno de la fórmula no baja la historia.
    const { data } = await api.post(`/medical-records/${medicalRecordId}/pdf-token`, { doc });
    if (!data.success) throw new Error('No se pudo generar el enlace de descarga');
    // Paso 2: abrir en pestaña nueva con dl_token (sin JWT en URL). El doc debe
    // ir también aquí: el backend lo compara con el del token.
    const base = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/api$/, '');
    window.open(
      `${base}/api/medical-records/${medicalRecordId}/pdf?dl_token=${data.token}&doc=${doc}`,
      '_blank');
    return null; // el blob ya no se devuelve — se abre en pestaña
  }
};

export default medicalRecordService;